import { Box, Container, Typography } from "@mui/material";
import { motion } from "framer-motion";
import aboutHeroImage from "../../assets/heroImg.jpg";

export default function AboutHero() {
  return (
    <Box
      sx={{
        minHeight: "90svh",
        position: "relative",
        display: "flex",
        alignItems: "center",
        backgroundImage: `url(${aboutHeroImage})`,
        // backgroundSize: "cover",
        // backgroundPosition: "center right",
        backgroundSize: "cover",
        backgroundPosition: { xs: "center", md: "right center" },
        backgroundRepeat: "no-repeat",
        backdropFilter: "blur(10px)",
      }}
    >
      <Container
        maxWidth="xl"
        sx={{
          position: "relative",
          zIndex: 2,
          pt: { xs: 14, md: 18 },
          pb: { xs: 10, md: 14 },
        }}
      >
        <Box
          sx={{
            display: "grid",
            gridTemplateColumns: { xs: "1fr", md: "1.1fr 0.9fr" },
            gap: { xs: 5, md: 8 },
            alignItems: "center",
          }}
        >
          {/* LEFT CONTENT */}
          <Box
            sx={{
              position: "relative",
              p: { xs: 3, md: 4 },
              borderRadius: "24px",

              /* Glass background */
              background: `
      linear-gradient(
        90deg,
        rgba(255,255,255,0.92) 0%,
        rgba(255,255,255,0.75) 55%,
        rgba(255,255,255,0.35) 100%
      )
    `,

              /* Blur effect */
              // backdropFilter: "blur(14px)",
              // WebkitBackdropFilter: "blur(14px)",

              /* Subtle depth */
              boxShadow: "0 20px 60px rgba(0,0,0,0.12)",
              border: "1px solid rgba(255,255,255,0.45)",
            }}
          >
            <motion.div
              initial={{ opacity: 0, y: 40 }}
              animate={{ opacity: 1, y: 0 }}
              transition={{ duration: 0.9 }}
            >
              <Typography
                sx={{
                  color: "var(--color-gold)",
                  letterSpacing: "0.22em",
                  fontSize: { xs: 11, md: 13 },
                  fontWeight: 500,
                  mb: 2.5,
                }}
              >
                ABOUT VISION X NEXUS
              </Typography>

              {/* HEADING – TWO COLOR */}
              <Typography
                sx={{
                  fontWeight: 600,
                  lineHeight: 1.1,
                  fontSize: {
                    xs: "1.9rem",
                    sm: "2.4rem",
                    md: "3.0rem",
                    lg: "3.4rem",
                  },

                  maxWidth: 720,
                }}
              >
                <Box
                  component="span"
                  sx={{ color: "var(--color-text-primary)" }}
                >
                  Crafting
                </Box>{" "}
                <Box component="span" sx={{ color: "var(--color-gold)" }}>
                  Trusted
                </Box>
                <br />
                <Box
                  component="span"
                  sx={{ color: "var(--color-text-primary)" }}
                >
                  Luxury
                </Box>{" "}
                {/* <Box
                  component="span"
                  sx={{
                    color: "var(--color-gold)",
                    borderBottom: "2px solid var(--color-gold)",
                    paddingBottom: "4px",
                    display: "inline-block",
                  }}
                >
                  UAE Real Estate
                </Box> */}
              </Typography>

              {/* DESCRIPTION */}
              <Typography
                sx={{
                  // color: "rgba(0, 0, 0, 0.88)",
                  color: "var(--color-text-muted)",

                  maxWidth: 600,
                  lineHeight: { xs: 1.7, md: 1.9 },
                  fontSize: { xs: 14, md: 16 },
                  mt: 3,
                  mb: 4,
                }}
              >
                Vision X Nexus is a luxury real estate agency built on
                integrity, market expertise, and personalized service —
                connecting discerning clients with exceptional properties across
                the UAE.
              </Typography>

              <Typography
                sx={{
                  color: "var(--color-gold)",
                  letterSpacing: "0.18em",
                  fontSize: { xs: 11, md: 13 },
                  fontWeight: 500,
                }}
              >
                TRUST • INTEGRITY • MARKET EXPERTISE
              </Typography>
            </motion.div>
          </Box>

          {/* RIGHT PANEL – SHOW ON ALL SCREENS */}
          <motion.div
            initial={{ opacity: 0, y: 30 }}
            animate={{ opacity: 1, y: 0 }}
            transition={{ duration: 0.9, delay: 0.2 }}
          >
            <Box
              sx={{
                p: { xs: 3, md: 4 },
                borderRadius: 4,
                background: "var(--color-white)",
                backdropFilter: "blur(14px)",
                border: "1px solid var(--color-gold)",
                boxShadow: "0 30px 70px rgba(0,0,0,0.18)",
              }}
            >
              {/* <Box
              sx={{
                p: { xs: 3, md: 4 },
                borderRadius: 4,
                background: `
                  linear-gradient(
                    180deg,
                    rgba(33,33,33,0.55) 0%,
                    rgba(33,33,33,0.35) 100%
                  )
                `,
                backdropFilter: "blur(14px)",
                border: "1px solid rgba(201,162,77,0.25)",
                boxShadow: "0 40px 90px rgba(0,0,0,0.55)",
              }}
            > */}
              <Typography
                sx={{
                  color: "var(--color-gold)",
                  fontSize: 12,
                  letterSpacing: "0.22em",
                  mb: 1.5,
                }}
              >
                OUR FOUNDATION
              </Typography>

              <Typography
                sx={{
                  // color: "var(--color-white)",
                  color: "var(--color-text-primary)",

                  fontSize: { xs: "1.2rem", md: "1.5rem" },
                  fontWeight: 600,
                  mb: 1.5,
                }}
              >
                A Legacy of Market Expertise
              </Typography>

              <Typography
                sx={{
                  // color: "rgba(255,255,255,0.8)",
                  color: "var(--color-text-muted)",

                  fontSize: 14,
                  lineHeight: 1.7,
                }}
              >
                Built on trust, long-term relationships, and deep insight into
                the UAE property market — serving buyers, sellers, and investors
                with precision and care.
              </Typography>
            </Box>
          </motion.div>
        </Box>
      </Container>
    </Box>
  );
}
